export default __webpack_public_path__ + "static/media/ANEXO_1_PREMIOS_IMPULSO_SUME_BY_SAINT_GOBAIN_2024.7bd57ec0.docx";